import * as _ from "lodash";
import { Components } from "formiojs";

const TextFieldComponent = Components.components.textarea;

export default class MiproPatientAddressTextField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproPatientAddressTextField",
            label: "Patient Address",
            key: "dbo.mipro.miproPatientAddress",
            placeholder: "Enter Patient Address", 
            disabled: false, 
            input: true
        });
    }


    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Patient Address",
            group: "basic",
            icon: "user-md",
            weight: 70,
            schema: MiproPatientAddressTextField.schema(),            
        };
    }
}

Components.addComponent("miproPatientAddressTextField", MiproPatientAddressTextField);